const setCustomVh = () => {
  // Set custom property for vh, based on visible viewport. Needed to fix message input pushed under screen in mobile Chrome and Safari
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

export default setCustomVh;